/** Remove decorative icons from an export clone, including html2canvas's generated ::before node. */
export function removeLinkFaviconsFromClone(root: HTMLElement) {
  const selector = 'a.affine-link-with-favicon';
  const links = [...root.querySelectorAll<HTMLElement>(selector)];
  if (root.matches(selector)) links.push(root);
  for (const link of links) {
    link.classList.remove('affine-link-with-favicon');
    link.style.removeProperty('--affine-link-favicon');
    // html2canvas materializes ::before as the first child before onclone.
    if (link.firstElementChild?.tagName === 'HTML2CANVASPSEUDOELEMENT') {
      link.firstElementChild.remove();
    }
  }
}
